import React, { useState } from "react";
import { outreach } from "./outreachApi";
export default function OutreachScoreForm({
  prospectId,
  campaigns,
  disabled,
  act
}) {
  const [value, setValue] = useState({
    campaign_id: "",
    evidence_source: "",
    genre: "",
    activity: "",
    audience: "",
    collaboration: ""
  });
  if (disabled) return <p>YouTube-sourced prospects use independent administrator priority; their API data is not automatically scored.</p>;
  return <details><summary>Campaign suitability scoring</summary><p>Use verified independent evidence. Leave unknown criteria blank. The result is a relevance assessment, not a likelihood of response.</p><form onSubmit={e => {
      e.preventDefault();
      const evidence = {};
      for (const k of ["genre", "activity", "audience", "collaboration"]) evidence[k] = value[k] === "" ? null : Number(value[k]);
      act(() => outreach(`prospects/${prospectId}/score`, {
        campaign_id: value.campaign_id,
        evidence_source: value.evidence_source,
        evidence
      }, "post"), "Campaign suitability and evidence saved.");
    }}><div className="bookstore-fields"><label>Campaign<select required value={value.campaign_id} onChange={e => setValue({
            ...value,
            campaign_id: e.target.value
          })}><option value="">Choose…</option>{campaigns.map(c => <option key={c.id} value={c.id}>{c.title}</option>)}</select></label><label>Evidence source / verified research notes<textarea required value={value.evidence_source} onChange={e => setValue({
            ...value,
            evidence_source: e.target.value
          })} /></label>{[["genre", "Genre relevance"], ["activity", "Recent activity"], ["audience", "Audience suitability"], ["collaboration", "Explicit collaboration suitability"]].map(([key, title]) => <label key={key}>{title} (0–100)<input type="number" min="0" max="100" value={value[key]} onChange={e => setValue({
            ...value,
            [key]: e.target.value
          })} /></label>)}</div><button>Save evidence-based score</button></form></details>;
}
